<button
  class="btn"
  color="primary"
  (click)="startUpload()"
  [disabled]="uploading"
  [class.loading]="filesLoading"
  class="loadable"
>
  <ng-content></ng-content>
</button>

<input
  type="file"
  #fileUpload
  id="fileUpload1"
  name="fileUpload"
  style="display: none"
  [accept]="accept"
/>
